export default __webpack_public_path__ + "static/media/logoAllcap.644e10db.jpeg";